import React, { useState } from "react";
import { Container, Row, Col, Button, Nav } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AppNavbar from "../components/AppNavbar"; // 🔹 Navbar import

const LegalPage = () => {
  const navigate = useNavigate();

const sections = [
  {
    id: "kvkk",
    title: "K.V.K.K",
    content: `
ESCULIFE HEALTH KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ AYDINLATMA METNİ

1. Veri Sorumlusu 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") uyarınca, kişisel verileriniz; veri sorumlusu olarak Esculife Health ("Şirket") tarafından aşağıda açıklanan kapsamda işlenebilecektir.

2. İşlenen Kişisel Verileriniz Majistral App ("Uygulama") üzerinden gerçekleştirdiğiniz üyelik işlemleri sırasında aşağıdaki kişisel verileriniz işlenmektedir:

Kimlik Bilgileri: Ad, Soyad.

İletişim Bilgileri: E-posta adresi, Telefon numarası.

Özlük/Mesleki Bilgiler: Meslek bilgisi.

İşlem Güvenliği Bilgileri: Üyelik şifresi (kriptolanmış olarak), log kayıtları ve IP adresleri.

3. Kişisel Verilerin İşlenme Amaçları Toplanan kişisel verileriniz;

Üyelik kaydının oluşturulması ve hesabın aktif hale getirilmesi,

Kullanıcı kimliğinin doğrulanması,

Uygulama üzerinden sunulan hizmetlerin yerine getirilmesi,

İletişim faaliyetlerinin yürütülmesi ve tarafınıza bilgilendirme yapılması,

Bilgi güvenliği süreçlerinin yürütülmesi, amaçlarıyla Kanun’un 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları dahilinde işlenecektir.

4. İşlenen Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda; kanunen yetkili kamu kurumlarına ve teknik altyapı hizmeti aldığımız tedarikçilere aktarılabilir.

⚠️ Yurtdışına Veri Aktarımı: Uygulamamızın teknik altyapısı ve veritabanı hizmetleri global standartlarda hizmet veren MongoDB üzerinde barındırılmaktadır. Verileriniz, hizmetin kesintisiz ve güvenli sunulabilmesi amacıyla, sunucuları Almanya (Frankfurt) lokasyonunda bulunan veri merkezlerinde saklanmaktadır. Bu kapsamda kişisel verileriniz, Kanun’un 9. maddesi uyarınca "Açık Rızanıza" istinaden yurtdışına aktarılmaktadır.

5. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi Kişisel verileriniz, Majistral App web sitesi/uygulaması üzerinden elektronik ortamda doldurduğunuz formlar aracılığıyla otomatik yollarla toplanmaktadır. Bu veriler, "Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması" ve "Veri sorumlusunun meşru menfaati" hukuki sebeplerine dayalı olarak işlenmektedir. (Yurtdışı aktarımı için ayrıca Açık Rıza hukuki sebebine dayanılmaktadır.)

6. Kişisel Veri Sahibinin Hakları (Madde 11) Kanun’un 11. maddesi uyarınca, veri sahibi olarak Şirketimize başvurarak;

Kişisel verilerinizin işlenip işlenmediğini öğrenme,

İşlenmişse buna ilişkin bilgi talep etme,

İşlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,

Yurt içinde veya yurt dışında aktarıldığı 3. kişileri bilme,

Eksik veya yanlış işlenmişse düzeltilmesini isteme,

Kanun’da öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme haklarına sahipsiniz.

7. İletişim Haklarınıza ilişkin taleplerinizi info@majistralapp.com adresine e-posta yoluyla iletebilirsiniz.
    `
  },

  {
    id: "acik-riza",
    title: "Açık Rıza Metni",
    content: `
ESCULIFE HEALTH YURTDIŞINA VERİ AKTARIMI AÇIK RIZA METNİ

İşbu beyan metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") kapsamında, Esculife Health ("Şirket") tarafından geliştirilen Majistral App ("Uygulama") hizmetlerinden faydalanmam sebebiyle toplanan kişisel verilerimin, yurtdışında bulunan sunuculara aktarılmasına ilişkindir.

Şirket tarafından sunulan KVKK Aydınlatma Metni'ni okudum ve anladım.

Uygulamanın teknik altyapısının sürekliliği, verilerin güvenliği ve hizmetin global standartlarda sunulabilmesi amacıyla;

Kimlik bilgilerimin (Ad, Soyad),

İletişim bilgilerimin (E-posta, Telefon),

Mesleki bilgilerimin (Meslek) ve

İşlem güvenliği verilerimin (Şifre, IP, Log kayıtları);

Şirket’in teknik altyapı hizmeti aldığı, sunucuları Almanya (Frankfurt) lokasyonunda bulunan MongoDB veri merkezlerine aktarılmasına, bu sunucularda saklanmasına ve işlenmesine; hiçbir baskı altında kalmadan, konu hakkında tam olarak aydınlatılmış şekilde, hür irademle AÇIK RIZA GÖSTERİYORUM.
    `
  },

  {
    id: "gizlilik",
    title: "Gizlilik Politikası",
    content: `
Son Güncelleme Tarihi: 03.12.2025

1. Giriş Esculife Health ("Şirket", "Biz") olarak, Majistral App ("Uygulama") kullanıcılarımızın ("Kullanıcı", "Siz") gizliliğine büyük önem veriyoruz. Bu Gizlilik Politikası, web sitemizi ve uygulamamızı kullandığınızda kişisel bilgilerinizin nasıl toplandığını, kullanıldığını, saklandığını ve korunduğunu açıklamaktadır.

2. Topladığımız Bilgiler Hizmetlerimizi sunabilmek için aşağıdaki bilgileri talep etmekte ve işlemekteyiz:

Kimlik Bilgileri: Adınız ve soyadınız.

İletişim Bilgileri: E-posta adresiniz ve telefon numaranız.

Mesleki Bilgiler: Meslek bilginiz.

Güvenlik Bilgileri: Hesabınıza giriş için oluşturduğunuz şifreniz (Güvenli kriptolama yöntemleri ile saklanır).

Teknik Veriler: IP adresiniz, tarayıcı türünüz, işletim sisteminiz ve uygulama kullanım loglarınız.

3. Bilgilerin Kullanım Amacı Toplanan veriler şu amaçlarla kullanılmaktadır:

Kullanıcı hesabının oluşturulması ve kimlik doğrulama işlemlerinin yapılması.

Uygulama içi hizmetlerin sorunsuz sunulması.

Müşteri desteği sağlanması ve sizinle iletişime geçilmesi.

Sistemin güvenliğinin sağlanması ve kötüye kullanımın önlenmesi.

4. Veri Saklama ve Sunucu Altyapısı Majistral App, modern ve güvenli bulut teknolojileri kullanmaktadır.

Sunucu Konumu: Verileriniz, yüksek güvenlik standartlarına sahip MongoDB altyapısı kullanılarak Almanya (Frankfurt) lokasyonundaki sunucularda saklanmaktadır.

Veri Güvenliği: Kişisel verilerinizin yetkisiz erişime, kaybolmaya veya ifşaya karşı korunması için endüstri standardı şifreleme (SSL/TLS) ve güvenlik önlemleri uygulanmaktadır. Şifreleriniz veritabanımızda asla açık metin (plain text) olarak tutulmaz, hashlenerek saklanır.

5. Çerezler (Cookies) Uygulamamızda oturumunuzu açık tutmak ve kullanıcı deneyimini iyileştirmek amacıyla Çerezler (Cookies) ve Yerel Depolama (Local Storage) teknolojileri kullanılabilir. Tarayıcı ayarlarınızdan çerezleri dilediğiniz zaman engelleyebilirsiniz, ancak bu durumda uygulamanın bazı özellikleri çalışmayabilir.

6. Üçüncü Taraflarla Paylaşım Kişisel bilgileriniz, yasal zorunluluklar (mahkeme kararları vb.) ve altyapı sağlayıcılarımız (örn. sunucu hizmeti) haricinde, izniniz olmaksızın üçüncü şahıslara satılmaz veya kiralanmaz.

7. Kullanıcı Hakları Kullanıcı olarak; verilerinize erişme, hatalı verilerin düzeltilmesini isteme veya hesabınızı ve verilerinizi tamamen silme hakkına sahipsiniz. Bu talepleriniz için bizimle iletişime geçebilirsiniz.

8. İletişim Bu Gizlilik Politikası ile ilgili her türlü sorunuz için bizimle iletişime geçebilirsiniz:

Şirket: Esculife Health

E-posta: info@majistralapp.com
    `
  },

  {
    id: "mesafeli",
    title: "Mesafeli Satış Sözleşmesi",
    content: `
MADDE 1 – TARAFLAR

1.1. SATICI (Hizmet Sağlayıcı):

Unvan: Esculife Health

E-posta: info@esculifehealth.com

1.2. ALICI (Kullanıcı):

Ad Soyad: [Kullanıcının üyelik formunda beyan ettiği ad soyad]

E-posta: [Kullanıcının e-posta adresi]

IP Adresi: [İşlem anındaki IP] (Bundan böyle "ALICI" olarak anılacaktır.)

MADDE 2 – KONU İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait Majistral App (web/mobil) uygulaması üzerinden elektronik ortamda siparişini verdiği, aşağıda nitelikleri ve satış fiyatı belirtilen dijital hizmetin (üyelik/abonelik) satışı ve ifası ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.

MADDE 3 – SÖZLEŞME KONUSU HİZMET VE FİYAT Elektronik ortamda satın alınan hizmetin cinsi, süresi ve vergiler dahil satış bedeli aşağıdaki gibidir:

Hizmet Adı: Majistral App Üyeliği / Dijital İçerik Erişimi

Hizmet Türü: Elektronik Hizmet (Yazılım/Uygulama Aboneliği)

Toplam Tutar: [Sipariş Tutarı] TL (KDV Dahil)

MADDE 4 – ÖDEME ŞEKLİ VE ONAY SÜRECİ (EFT/HAVALE) 4.1. ALICI, satın alma işlemi sırasında ödemeyi yalnızca Havale/EFT yöntemi ile yapacağını kabul ve beyan eder. 4.2. Ödeme bilgileri (IBAN ve Banka Bilgileri) sipariş aşamasında ALICI'ya sunulmuştur. 4.3. Hizmetin ifası (üyeliğin/içeriğin aktif hale getirilmesi), ALICI tarafından yapılan ödemenin SATICI'nın banka hesaplarına geçmesinden ve SATICI tarafından teyit edilmesinden sonra gerçekleşecektir. 4.4. Sipariş tarihinden itibaren 3 iş günü içinde ödemesi yapılmayan siparişler, SATICI tarafından iptal edilebilir.

MADDE 5 – TESLİMAT VE İFA 5.1. Sözleşme konusu hizmet, fiziksel bir teslimat gerektirmeyen, anlık ifa edilen gayrimaddi bir hizmettir. 5.2. Ödemenin teyit edilmesini takiben, ALICI'nın üyeliği/erişimi sistem üzerinden otomatik veya manuel olarak aktif hale getirilecektir.

MADDE 6 – CAYMA HAKKI VE İSTİSNALARI 6.1. 6502 sayılı Kanun ve Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesinin (ğ) bendi uyarınca; "Elektronik ortamda anında ifa edilen hizmetler veya tüketiciye anında teslim edilen gayrimaddi mallar" cayma hakkının istisnasıdır. 6.2. Majistral App üzerinden sunulan hizmet, elektronik ortamda anında ifa edilen bir hizmet niteliğinde olduğundan, ALICI'nın ödeme yapıp hizmete erişim sağladıktan sonra cayma ve ücret iadesi talep etme hakkı yasal olarak bulunmamaktadır. ALICI, işbu sözleşmeyi onaylayarak bu durumu peşinen kabul eder.

MADDE 7 – GENEL HÜKÜMLER 7.1. ALICI, Majistral App internet sitesinde sözleşme konusu hizmetin temel nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini beyan eder. 7.2. Doğal afetler, altyapı sorunları veya SATICI'nın kontrolü dışında gelişen teknik arızalar nedeniyle hizmetin verilememesi durumunda SATICI sorumlu tutulamaz.

MADDE 8 – UYUŞMAZLIKLARIN ÇÖZÜMÜ İşbu sözleşmenin uygulanmasından doğacak uyuşmazlıklarda, Ticaret Bakanlığı'nca ilan edilen değere kadar Tüketici Hakem Heyetleri ile ALICI'nın veya SATICI'nın yerleşim yerindeki Tüketici Mahkemeleri yetkilidir.

TARİH: - SATICI: Esculife Health ALICI: [Kullanıcı Adı Soyadı]

(İşbu sözleşme elektronik ortamda ALICI tarafından okunarak onaylanmıştır.)
    `
  },

  {
    id: "cerez",
    title: "Çerez Politikası",
    content: `
Son Güncelleme: 03.12.2025

1. Giriş Esculife Health ("Şirket") olarak, Majistral App ("Uygulama" veya "Web Sitesi") ziyaretçilerimizin ve üyelerimizin gizliliğine ve kişisel verilerinin korunmasına büyük önem veriyoruz. Bu politika, sitemizde kullanılan Çerezler (Cookies) ve Yerel Depolama (Local Storage) gibi izleme teknolojilerinin ne olduğunu, hangi amaçlarla kullanıldığını ve bunları nasıl yönetebileceğinizi açıklamaktadır.

2. Çerez (Cookie) ve Yerel Depolama Nedir?

Çerezler: Ziyaret ettiğiniz web siteleri tarafından tarayıcınız aracılığıyla cihazınıza veya ağ sunucusuna depolanan küçük metin dosyalarındır.

Yerel Depolama (Local Storage): Verilerin tarayıcınızda süresiz olarak veya siz silene kadar saklanmasını sağlayan, çerezlere benzer ancak daha fazla veri tutabilen bir web teknolojisidir.

3. Hangi Tür Teknolojileri Kullanıyoruz? Majistral App üzerinde aşağıdaki kategorilerde depolama teknolojileri kullanılmaktadır:

A. Zorunlu (Teknik) Depolama: Uygulamanın düzgün çalışması için mutlak gerekli olan verilerdir. Bu veriler olmadan uygulamanın belirli kısımlarını (örneğin; hesabınıza giriş yapmak) kullanamazsınız.

Kullanım Örneği: Kullanıcı giriş yaptığında oluşturulan Kimlik Doğrulama Token'ı (Auth Token) tarayıcınızın "Local Storage" alanında saklanır. Bu, sayfalar arasında gezinirken oturumunuzun açık kalmasını sağlar.

B. İşlevsel Çerezler: Size daha kişiselleştirilmiş bir deneyim sunmak için kullanılan teknolojilerdir.

Kullanım Örneği: Dil tercihiniz veya tema (karanlık/aydınlık mod) seçimleriniz.

C. Performans ve Analiz Çerezleri: Uygulamamızın nasıl kullanıldığını analiz ederek, hataları tespit etmemize ve hizmet kalitesini artırmamıza yardımcı olur.

Kullanım Örneği: Hangi sayfaların daha çok ziyaret edildiği, yüklenme süreleri vb.

4. Kullanılan Verilerin Saklanma Yeri Teknik altyapımız gereği, oturum bilgileriniz ve tercihleriniz cihazınızdaki tarayıcı hafızasında tutulurken; bu verilerin işlendiği ana sistemler ve veritabanı Almanya (Frankfurt) lokasyonlu güvenli sunucularda barındırılmaktadır.

5. Çerezleri ve Depolamayı Nasıl Yönetebilirsiniz? Çoğu internet tarayıcısı çerezleri ve yerel depolama verilerini otomatik olarak kabul edecek şekilde ayarlıdır. Ancak tarayıcı ayarlarınızı değiştirerek bunları engelleyebilir veya silebilirsiniz.

Verileri Silme: Tarayıcı geçmişinizi temizlerken "Çerezler ve site verileri" seçeneğini işaretleyerek Majistral App'e ait giriş bilgilerinizi (Token) silebilirsiniz. Bu durumda oturumunuz kapanacaktır.

Ayarları Değiştirme: Chrome, Mozilla Firefox, Safari gibi tarayıcıların "Ayarlar > Gizlilik ve Güvenlik" sekmelerinden çerez kullanımını kısıtlayabilirsiniz.

6. İletişim Bu politika hakkında sorularınız için bizimle iletişime geçebilirsiniz: Esculife Health E-posta: info@majistralapp.com
    `
  },

  {
    id: "uyelik",
    title: "Üyelik Sözleşmesi",
    content: `
1. TARAFLAR

1.1. İşletmeci: Esculife Health (Bundan böyle "ŞİRKET" olarak anılacaktır.) E-posta: info@majistralapp.com

1.2. Üye: Majistral App web sitesine/uygulamasına üye olan, kayıt formunda talep edilen bilgileri dolduran gerçek veya tüzel kişi. (Bundan böyle "ÜYE" olarak anılacaktır.)

2. KONU İşbu sözleşmenin konusu, ŞİRKET'in sahibi olduğu Majistral App (web ve mobil) platformundan ÜYE'nin faydalanma şartlarının, tarafların hak ve yükümlülüklerinin belirlenmesidir.

3. ÜYELİK ŞARTLARI 3.1. Üyelik, ÜYE'nin platform üzerindeki kayıt formunu doldurması, gerekli onayları vermesi ve (varsa) ücretli hizmetler için ödeme sürecinin tamamlanarak ŞİRKET tarafından onaylanması ile aktifleşir. 3.2. ÜYE, kayıt formunda beyan ettiği (Ad, Soyad, E-posta, Telefon, Meslek) bilgilerin doğru ve güncel olduğunu taahhüt eder. Yanlış bilgi verilmesinden doğacak zararlardan ÜYE sorumludur. 3.3. ÜYE'nin hesabının aktifleşmesi, özellikle ücretli üyeliklerde, ödemenin ŞİRKET hesaplarına (Havale/EFT yoluyla) geçmesi ve ŞİRKET tarafından teyit edilmesi şartına bağlı olabilir.

4. TARAFLARIN HAK VE YÜKÜMLÜLÜKLERİ

4.1. ÜYE'nin Yükümlülükleri:

ÜYE, sisteme giriş için belirlediği şifreyi gizli tutmakla yükümlüdür. Şifrenin üçüncü kişilerce kullanılması nedeniyle doğacak zararlardan ŞİRKET sorumlu değildir.

ÜYE, platformu kullanırken yasal mevzuata, genel ahlak kurallarına ve üçüncü kişilerin haklarına riayet edeceğini kabul eder.

ÜYE, platformu hiçbir şekilde kamu düzenini bozucu, genel ahlaka aykırı, başkalarını rahatsız ve taciz edici şekilde kullanamaz.

4.2. ŞİRKET'in Hak ve Yükümlülükleri:

ŞİRKET, teknik arızalar, bakım çalışmaları veya mücbir sebepler (internet kesintileri, siber saldırılar vb.) nedeniyle hizmette yaşanacak kesintilerden sorumlu tutulamaz.

Yurtdışı Altyapı: ŞİRKET, hizmetin global standartlarda sunulabilmesi için sunucu ve veritabanı altyapısını yurtdışında (Frankfurt/Almanya) barındırma hakkına sahiptir. ÜYE, bu sözleşmeyi kabul ederek verilerinin teknik zorunluluk gereği yurtdışında tutulacağını bilir ve kabul eder.

ŞİRKET, herhangi bir gerekçe göstermeksizin, sözleşmeye aykırı davranan ÜYE'nin üyeliğini askıya alma veya sonlandırma hakkını saklı tutar.

5. GİZLİLİK VE KİŞİSEL VERİLER ÜYE'ye ait kişisel veriler, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve ilgili mevzuata uygun olarak, ŞİRKET'in "Aydınlatma Metni" ve **"Gizlilik Politikası"**nda belirtilen amaçlarla işlenir. ÜYE, kayıt olurken bu metinleri okuduğunu kabul eder.

6. FİKRİ MÜLKİYET Majistral App arayüzü, yazılım kodları (Backend ve Frontend), veritabanı yapısı, tasarımı, logosu ve içeriği ŞİRKET'in mülkiyetindedir. ÜYE, bu materyalleri kopyalayamaz, değiştiremez veya ticari amaçla kullanamaz.

7. SÖZLEŞME DEĞİŞİKLİKLERİ ŞİRKET, işbu sözleşme koşullarını dilediği zaman tek taraflı olarak değiştirme hakkına sahiptir. Değişiklikler platformda yayınlandığı tarihte yürürlüğe girer.

8. UYUŞMAZLIKLARIN ÇÖZÜMÜ VE DELİL SÖZLEŞMESİ İşbu sözleşmeden doğabilecek uyuşmazlıklarda ŞİRKET'in defter ve elektronik kayıtları (sunucu logları, veritabanı kayıtları, e-posta yazışmaları) kesin delil teşkil eder. Uyuşmazlıkların çözümünde Mahkemeler ve İcra Daireleri yetkilidir.

9. YÜRÜRLÜK ÜYE'nin, elektronik ortamda "Üyelik Sözleşmesi'ni okudum ve kabul ediyorum" kutucuğunu işaretlemesi ve kayıt işlemini tamamlaması ile işbu sözleşme kurulmuş ve yürürlüğe girmiş sayılır.
    `
  },

  {
    id: "sorumluluk",
    title: "Tıbbi Sorumluluk Reddi",
    content: `
ÖNEMLİ UYARI: Lütfen uygulamayı kullanmadan önce dikkatlice okuyunuz.

1. Sadece Bilgilendirme Amaçlıdır
Esculife Health tarafından geliştirilen Majistral App ("Uygulama") içerisinde yer alan metinler, grafikler, görseller, ilaç formülleri, dozaj hesaplamaları ve diğer tüm içerikler yalnızca genel bilgilendirme ve eğitim amacıyla oluşturulmuştur.

2. Tıbbi Tavsiye Değildir
Uygulama içeriğindeki hiçbir bilgi; tıbbi tavsiye, profesyonel teşhis veya tedavi yerine geçmez.

Uygulama içerisindeki majistral formüller ve hesaplamalar destekleyici niteliktedir. Reçeteleme veya hazırlama aşamasında nihai mesleki karar ve kontrol sorumluluğu tamamen uygulayıcıya (hekim/eczacı) aittir.

3. Majistral Formüller ve Dozajlar
Uygulamada yer alan majistral formülasyon bilgileri, farmasötik literatürden derlenmiş olabilir. Ancak; tıp ve eczacılık bilimindeki güncel gelişmeler, kişisel alerjiler, ilaç etkileşimleri veya kontrendikasyonlar nedeniyle bu bilgiler her hasta için uygun olmayabilir. Esculife Health, formüllerin uygulanmasından doğabilecek yan etkiler veya hatalı dozajlardan sorumlu tutulamaz.

4. Garanti Feragati
Esculife Health, uygulama içeriğinin doğruluğu, güncelliği ve tamlığı konusunda makul çabayı gösterse de; içeriğin hatasız olduğunu garanti etmez. Uygulamanın kullanımından kaynaklanan doğrudan veya dolaylı hiçbir zarardan Şirket sorumlu tutulamaz.
    `
  }
];


  const [active, setActive] = useState(sections[0].id);

  return (
    <>
      {/* 🔹 Navbar her sayfanın üstünde sabit */}
      <AppNavbar />

      <section
        className="legal-content py-5"
        style={{
          background: "linear-gradient(180deg, #E7F5F2 0%, #FFFFFF 100%)",
          minHeight: "100vh",
        }}
      >
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-5"
          >
            <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
              Yasal Bilgiler
            </h2>
            <p className="text-muted">
              Majistral App’in kullanım koşulları, gizlilik politikaları ve yasal yükümlülükleri.
            </p>
          </motion.div>

          <Row>
            <Col md={4} className="mb-4 mb-md-0">
              <Nav className="flex-column rounded-4 shadow-sm bg-white p-3">
                {sections.map((item) => (
                  <Nav.Link
                    key={item.id}
                    onClick={() => setActive(item.id)}
                    active={active === item.id}
                    style={{
                      color: active === item.id ? "#2D8A7A" : "#333",
                      fontWeight: active === item.id ? "600" : "400",
                      borderRadius: "10px",
                      padding: "10px 15px",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {item.title}
                  </Nav.Link>
                ))}
              </Nav>

              <div className="mt-4 text-center">
                <Button
                  variant="outline-primary"
                  onClick={() => navigate("/")}
                  className="hover-scale"
                >
                  <FaArrowLeft className="me-2" />
                  Ana Sayfaya Dön
                </Button>
              </div>
            </Col>

            <Col md={8}>
              {sections.map((item) =>
                active === item.id ? (
                  <motion.div
                    key={item.id}
                    initial={{ opacity: 0, x: 30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4 }}
                    className="bg-white rounded-4 shadow-sm p-4"
                  >
                    <h4 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
                      {item.title}
                    </h4>
                    <p className="text-muted" style={{ lineHeight: "1.7" }}>
                      {item.content}
                    </p>
                  </motion.div>
                ) : null
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default LegalPage;
